export const Nadiad = {
    title: "Nadiad",
    title1: "(Cultural and Religious Hub)",

    intro: "Nadiad, a city in the Kheda district of Gujarat, is known for its deep cultural and religious significance. It is a key center for educational institutions, temples, and is an important transit point between major cities like Ahmedabad and Vadodara.",

    attractions: [
        {
            name: "Shree Santram Mandir",
            description: "The Shree Santram Mandir is a revered temple dedicated to Lord Santram, known for its spiritual importance and serene atmosphere. It attracts a large number of devotees, especially during festivals.",
            location: "Nadiad, Gujarat",
            timings: "6:00 AM to 8:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "Morning or Evening",
            activities: [
                "Attend the aarti and prayer sessions",
                "Meditate and enjoy the peaceful surroundings",
                "Participate in the temple's religious festivals",
                "Explore the temple’s architecture",
                "Engage with the local devotees"
            ],
            mapLink: "https://maps.app.goo.gl/6mvMz2rYazKz2V9C9",
        },
        {
            name: "Ranchhodrai Dakor Temple",
            description: "Located near Nadiad, this temple is dedicated to Lord Krishna in his Ranchhodrai form. The temple is renowned for its religious significance and draws pilgrims from across the region.",
            location: "Dakor, near Nadiad, Gujarat",
            timings: "5:00 AM to 9:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "Morning or Evening",
            activities: [
                "Offer prayers and attend aarti",
                "Admire the temple’s architecture",
                "Engage in religious rituals",
                "Participate in the temple's festivals",
                "Explore the serene temple surroundings"
            ],
            mapLink: "https://maps.app.goo.gl/FwqjVdZmGELuN91C7",
        },
        {
            name: "Nadiad Clock Tower",
            description: "The Nadiad Clock Tower is a historical landmark in the city. It stands as a symbol of Nadiad’s heritage and is a popular meeting point for locals. The tower offers a glimpse into the city's colonial past.",
            location: "Nadiad, Gujarat",
            timings: "Open throughout the day",
            ticket: "Free Entry",
            bestTimeToVisit: "Evening",
            activities: [
                "Admire the clock tower's architecture",
                "Take photos of the landmark",
                "Learn about the history of Nadiad",
                "Visit the surrounding local market",
                "Enjoy local snacks and food in the area"
            ],
            mapLink: "https://maps.app.goo.gl/jMQw6Nk76seBQ3aP9",
        },
        {
            name: "Gopi Talav",
            description: "Gopi Talav is a picturesque water body in Nadiad that provides a peaceful environment for relaxation. The serene atmosphere makes it a great spot for nature lovers and those seeking some quiet time.",
            location: "Nadiad, Gujarat",
            timings: "Open throughout the day",
            ticket: "Free Entry",
            bestTimeToVisit: "Early Morning or Evening",
            activities: [
                "Relax by the water",
                "Enjoy a peaceful walk around the lake",
                "Photography of the natural beauty",
                "Birdwatching",
                "Enjoy a picnic with family and friends"
            ],
            mapLink: "https://maps.app.goo.gl/M22QH42ySxPrrG2aA",
        },
        {
            name: "Swaminarayan Mandir",
            description: "This is a prominent temple in Nadiad, dedicated to Swaminarayan. Known for its architectural beauty and peaceful surroundings, the temple attracts devotees and visitors from all over the country.",
            location: "Nadiad, Gujarat",
            timings: "6:00 AM to 8:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "Morning or Evening",
            activities: [
                "Participate in the daily prayer and aarti",
                "Meditate in the temple complex",
                "Admire the temple’s intricate carvings and architecture",
                "Explore the surrounding garden area",
                "Engage with the community during religious events"
            ],
            mapLink: "https://maps.app.goo.gl/8JzmqWxRuhwaGfQk8",
        },
        {
            name: "Sardar Vallabhbhai Patel Institute of Technology",
            description: "This is an educational institute located in Nadiad, founded in honor of Sardar Vallabhbhai Patel. It is an important institution in the region, attracting students from all over the country. The campus is known for its peaceful and green surroundings.",
            location: "Nadiad, Gujarat",
            timings: "9:00 AM to 5:00 PM",
            ticket: "Free Entry (only for campus visit)",
            bestTimeToVisit: "Weekdays",
            activities: [
                "Take a walk around the beautiful campus",
                "Explore the educational infrastructure",
                "Interact with students and faculty",
                "Learn about Sardar Vallabhbhai Patel’s contributions",
                "Relax in the campus's serene environment"
            ],
            mapLink: "https://maps.app.goo.gl/KK4h53b6qYNty7gH6",
        },
    ]
};
